<template>
  <div>
    <g-master :name="master.endpoint"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              :actions="master.actions"
              @action="masterAction"
              ref="masterComponent"
              @params="paramsTable"
    >
      <template slot="customButton">
        <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
      </template>
    </g-master>
    <form-plano-ss-2388 @refreshTable="loadData()" v-if="plano_ss_2388" :iPlano="plano_ss_2388" :endpoint="endpoint"
                        :readonlyInput="readonly" :visibleButton="isvisibleButton" :canEdit="canEdit"/>
  </div>
</template>
<script>
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'
  import JsUtils from '@/util/JsUtils'

  export default {
    props: ['endpoint'],
    mounted () {
      this.httpClient = new HttpUtil()
      if (!(this.endpoint === 'plano_ss_hist_2388')) {
        this.isvisibleButton = true
        this.readonly = false
        this.master.actions[0] = {
          name: 'create',
          text: 'Crear',
          permisos: [],
          props: {icon: 'plus', type: 'button'}
        }
        this.master.actions[1] = {
          name: 'rowClone',
          text: 'Clonar',
          permisos: [],
          props: {icon: 'plus', type: 'button'}
        }
        this.canEdit = true
        this.master.tableSetup.actions.actions[0] = {
          name: 'masterDelete',
          text: 'Eliminar',
          permisos: [],
          props: {size: 'small', icon: 'delete', type: 'link'}
        }
      } else {
        this.isvisibleButton = false
        this.readonly = true
        if (this.$userIsInrol('Management')) {
          this.canEdit = true
        }
      }
    },
    data () {
      return {
        fileNameExcel: 'plano_ss_2388',
        paramsT: {},
        endpointExcel: `seguridad_social_${this.endpoint}/downloadExcel`,
        isvisibleButton: false,
        canEdit: false,
        readonly: false,
        master: {
          actions: [],
          endpoint: this.endpoint,
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Compañia', dataIndex: 'company', sorter: true},
              {title: 'Tipo registro', dataIndex: 'tipo_registro', sorter: true},
              {title: 'Tipo doc', dataIndex: 'tipo_doc', sorter: true},
              {title: 'IdPerson', dataIndex: 'id_person', sorter: true},
              {title: 'Codigo', dataIndex: 'id_emp', sorter: true},
              {title: 'Mes', dataIndex: 'month', sorter: true},
              {title: 'Año', dataIndex: 'year', sorter: true},
              {title: 'Tipo cotizante', dataIndex: 'tipo_cotizante', sorter: true},
              {title: 'Subtipo cotizante', dataIndex: 'subtipo_cotizante', sorter: true},
              {title: 'Primer apellido', dataIndex: 'last_name1', sorter: true},
              {title: 'Segundo apellido', dataIndex: 'last_name2', sorter: true},
              {title: 'Primer nombre', dataIndex: 'name1', sorter: true},
              {title: 'Segundo nombre', dataIndex: 'name2', sorter: true},
              {title: 'Ingreso del mes', dataIndex: 'secuencia', sorter: true},
              {title: 'Salario', dataIndex: 'salario', sorter: true},
              {title: 'Integral', dataIndex: 'integral', sorter: true},
              {title: 'Horas laboradas', dataIndex: 'horas_labor', sorter: true},
              {title: 'Fecha radicar extension', dataIndex: 'fecha_rad_ext_desc', sorter: true},
              {title: 'Sln', dataIndex: 'sln_desc', sorter: true},
              {title: 'Fecha ini sln', dataIndex: 'fecha_ini_sln_desc', sorter: true},
              {title: 'Fecha fin sln', dataIndex: 'fecha_fin_sln_desc', sorter: true},
              {title: 'Ige', dataIndex: 'ige_desc', sorter: true},
              {title: 'Fecha ini ige', dataIndex: 'fecha_ini_ige_desc', sorter: true},
              {title: 'Fecha fin ige', dataIndex: 'fecha_fin_ige_desc', sorter: true},
              {title: 'Lma', dataIndex: 'lma_desc', sorter: true},
              {title: 'Fecha ini lma', dataIndex: 'fecha_ini_lma_desc', sorter: true},
              {title: 'Fecha fin lma', dataIndex: 'fecha_fin_lma_desc', sorter: true},
              {title: 'Vac', dataIndex: 'vac_desc', sorter: true},
              {title: 'Fecha ini vacl', dataIndex: 'fecha_ini_vacl_desc', sorter: true},
              {title: 'Fecha fin vacl', dataIndex: 'fecha_fin_vacl_desc', sorter: true},
              {title: 'Vct', dataIndex: 'vct_desc', sorter: true},
              {title: 'Fecha ini vct', dataIndex: 'fecha_ini_vct_desc', sorter: true},
              {title: 'Fecha fin vct', dataIndex: 'fecha_fin_vct_desc', sorter: true},
              {title: 'Ing', dataIndex: 'ing_desc', sorter: true},
              {title: 'Fecha ingreso', dataIndex: 'fecha_ingreso_desc', sorter: true},
              {title: 'Ret', dataIndex: 'ret_desc', sorter: true},
              {title: 'Fecha retiro', dataIndex: 'fecha_retiro_desc', sorter: true},
              {title: 'Vsp', dataIndex: 'vsp_desc', sorter: true},
              {title: 'Fecha ini vsp', dataIndex: 'fecha_ini_vsp_desc', sorter: true},
              {title: 'IRP', dataIndex: 'irp', sorter: true},
              {title: 'Fecha ini irl', dataIndex: 'fecha_ini_irl_desc', sorter: true},
              {title: 'Fecha fin irl', dataIndex: 'fecha_fin_irl_desc', sorter: true},
              {title: 'Cor', dataIndex: 'cor_desc', sorter: true},
              {title: 'Avp', dataIndex: 'avp_desc', sorter: true},
              {title: 'Tdp', dataIndex: 'tdp_desc', sorter: true},
              {title: 'Tae', dataIndex: 'tae_desc', sorter: true},
              {title: 'Tde', dataIndex: 'tde_desc', sorter: true},
              {title: 'Vst', dataIndex: 'vst_desc', sorter: true},
              {title: 'Tap', dataIndex: 'tap_desc', sorter: true},
              {title: 'Novsal', dataIndex: 'novsal', sorter: true},
              {title: 'AFP', dataIndex: 'afp', sorter: true},
              {title: 'Dias AFP', dataIndex: 'dias_afp', sorter: true},
              {title: 'IBC AFP', dataIndex: 'ibc_afp', sorter: true},
              {title: 'IBC CCF', dataIndex: 'ibc_ccf', sorter: true},
              {title: 'Tarifa AFP', dataIndex: 'tarifa_afp', sorter: true},
              {title: 'Aporte AFP', dataIndex: 'aporte_afp', sorter: true},
              {title: 'Valor Nomina AFP', dataIndex: 'valor_nomina_afp', sorter: true},
              {title: 'Aporte empresa AFP', dataIndex: 'aporte_empresa_afp', sorter: true},
              {title: 'Total AFP', dataIndex: 'total_afp', sorter: true},
              {title: 'Aporte solidaridad', dataIndex: 'aporte_solid', sorter: true},
              {title: 'Aporte subcuenta', dataIndex: 'aporte_subcta', sorter: true},
              {title: 'Valor nomina solid', dataIndex: 'valor_nomina_solid', sorter: true},
              {title: 'Valor nomina subcta', dataIndex: 'valor_nomina_subcta', sorter: true},
              {title: 'Diferencia solidaridad', dataIndex: 'diferencia_solid', sorter: true},
              {title: 'AFP tras', dataIndex: 'afptras', sorter: true},
              {title: 'EPS', dataIndex: 'eps', sorter: true},
              {title: 'IBC EPS', dataIndex: 'ibc_eps', sorter: true},
              {title: 'Dias EPS', dataIndex: 'dias_eps', sorter: true},
              {title: 'Tarifa EPS', dataIndex: 'tarifa_eps', sorter: true},
              {title: 'Aporte EPS', dataIndex: 'aporte_eps', sorter: true},
              {title: 'Valor Nomina EPS', dataIndex: 'valor_nomina_eps', sorter: true},
              {title: 'Aporte empresa EPS', dataIndex: 'aporte_empresa_eps', sorter: true},
              {title: 'Valor UPC', dataIndex: 'valor_upc', sorter: true},
              {title: 'EPS tras', dataIndex: 'epstras', sorter: true},
              {title: 'Dias ARP', dataIndex: 'dias_arp', sorter: true},
              {title: 'IBC ARP', dataIndex: 'ibc_arp', sorter: true},
              {title: 'Tarifa ARP', dataIndex: 'tarifa_arp', sorter: true},
              {title: 'Centro trabajo', dataIndex: 'centro_trabajo', sorter: true},
              {title: 'Aporte ARP', dataIndex: 'aporte_arp', sorter: true},
              {title: 'CCF', dataIndex: 'ccf', sorter: true},
              {title: 'Dias CCF', dataIndex: 'dias_ccf', sorter: true},
              {title: 'Tarifa CCF', dataIndex: 'tarifa_ccf', sorter: true},
              {title: 'Aporte CCF', dataIndex: 'aporte_ccf', sorter: true},
              {title: 'Tarifa SENA', dataIndex: 'tarifa_sena', sorter: true},
              {title: 'Aporte SENA', dataIndex: 'aporte_sena', sorter: true},
              {title: 'Tarifa ICBF', dataIndex: 'tarifa_icbf', sorter: true},
              {title: 'Aporte ICBF', dataIndex: 'aporte_icbf', sorter: true},
              {title: 'Tarifa ESAP', dataIndex: 'tarifa_esap', sorter: true},
              {title: 'Aporte ESAP', dataIndex: 'aporte_esap', sorter: true},
              {title: 'Tarifa MEN', dataIndex: 'tarifa_men', sorter: true},
              {title: 'Aporte MEN', dataIndex: 'aporte_men', sorter: true},
              {title: 'Ley1607 EXO', dataIndex: 'ley1607_exo', sorter: true},
              {title: 'Otros parafiscales', dataIndex: 'ibcotro_paraf', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado', dataIndex: 'modified_on', sorter: true}
            ],
            allowSelect: true,
            selectedRows: [],
            selectedRowKeys: [],
            actions: {
              actions: []
            }
          }
        }
      }
    },
    methods: {
      loadData () {
        this.$refs.masterComponent.$refs.datatable.loadData()
      },
      createOrClone (title, content) {
        let req = this.plano_ss_2388
        if (title === 'Crear') {
          req = {
            id: -1,
            sln: false,
            ige: false,
            lma: false,
            vac: false,
            vct: false,
            ing: false,
            ret: false,
            vsp: false,
            cor: false,
            tdb: false,
            tae: false,
            tde: false,
            vst: false,
            tap: false,
            irp: null
          }
        }
        this.$confirm({
          title: title,
          content: content,
          onOk: () => {
            return new Promise((resolve, reject) => {
              this.httpClient.getInstance().post(this.master.endpoint, {
                ...req
              })
                .then((response) => {
                  this.$refs.masterComponent.$refs.datatable.data.unshift(response.data)
                  this.$refs.masterComponent.$refs.datatable.handleRadioSelection(response.data)
                  this.master.tableSetup.selectedRowKeys = [response.data.id]
                  this.master.tableSetup.selectedRows = [response.data]
                  resolve()
                })
                .catch((error) => {
                  Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible ' + title + ' el registro'))
                  reject(error)
                })
            })
          },
          onCancel () { }
        })
      },
      masterAction (action) {
        switch (action.action) {
          case 'rowClone':
            if (JsUtils.isEmpty(this.plano_ss_2388)) {
              Mensajes.error('Error', 'Selecciona una fila para colonar')
              return
            }
            this.createOrClone('Clonar', '¿Está seguro que desea clonar el registro?')
            break
          case 'create':
            this.createOrClone('Crear', '¿Está seguro que desea crear el registro?')
            break
        }
      },
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      plano_ss_2388 () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0] : null
      },
      paramsExcel () {
        return {...this.paramsT}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Consultas/PlanoSs2388.vue